// extracted by mini-css-extract-plugin
export default {"searchBar_wrapper":"SearchBar_searchBar_wrapper__DNUdG","label":"SearchBar_label__4uG7W"};